import EFTB from '@images/banner/1_KV iMedical Card Elite 6000px 1480px BM.png';
import ELIB from '@images/banner/EzyMedical BM - Homepage Banner (EDP).png';
import ELIB_Mobile from '@images/banner/mobile/EzyMedical BM - Mobile Banner (EDP).png';
import EFTB_Mobile from '@images/banner/mobile/1_KV iMedical Card Elite 390px 430px BM.jpg';

export default {
  banner: {
    'iMedical-card-elite': {
      headline: 'i-MedicalCard Elite',
      subheadline:
        'Apabila bercerita tentang kesihatan, pelan Etiqa i-MedicalCard Elite setia bersama anda dan menawarkan perlindungan yang terbaik. Dapatkan pelan peringkat atasan pada harga yang berpatutan sama ada anda kategori anak muda, berusia ataupun mana-mana peringkat usia anda, kami sedia untuk memberikan anda ketenangan fikiran yang anda perlukan.',
      productLink:
        'https://www.etiqa.com.my/v2/insurans-takaful-kesihatan/imedicalcardelite',
      image: {
        desktop: EFTB,
        mobile: EFTB_Mobile,
      },
    },
    'ezy-medical': {
      headline: 'Kesejahteraan Mental Anda Tidak Patut Diabaikan',
      subheadline:
        'Pelan perubatan komprehensif yang menyediakan perlindungan seperti rawatan hospital dan pembedahan, termasuk rundingan dan rawatan psikiatri pesakit luar.',
      productLink:
        'https://www.etiqa.com.my/v2/insurans-takaful-kesihatan/ezymedical',
      image: {
        desktop: ELIB,
        mobile: ELIB_Mobile,
      },
    },
    'easy-health': {
      headline: 'EasyHealth First',
      subheadline:
        'Discover our standalone medical plan designed to provide comprehensive hospital and surgical benefits. This plan also includes coverage for outpatient psychiatric consultation and treatment, ensuring holistic care for your mental and physical health needs.',
      productLink: '#',
      image: {
        desktop: ELIB,
        mobile: ELIB_Mobile,
      },
    },
    clickHere: '<a>Klik di sini</a> untuk maklumat lanjut.',
  },
  keyBenefits: 'Manfaat Utama',
  productKeyBenefits: {
    'iMedical-card-elite': {
      lifeTime: {
        title: 'Perlindungan Perubatan Sepanjang Hayat Tanpa Had',
        description:
          'Dapatkan perlindungan perubatan sepanjang hayat tanpa had dengan had tahunan yang tinggi sehingga RM250,000.',
      },
      dengue: {
        title: 'Caj Rawatan Demam Denggi',
        description:
          'Dapatkan perlindungan untuk caj rawatan demam denggi pesakit luar termasuk rundingan, ujian pemeriksaan dan ubat-ubatan sehingga RM2,000.',
      },
      healthCare: {
        title: 'Akses Perkhidmatan Kesihatan melalui Aplikasi Etiqa+',
        description:
          'Dapatkan panduan arah ke Hospital Panel Etiqa yang terdekat, semak kelayakan perubatan anda, mohon Surat Jaminan, semak baki perlindungan perubatan anda,nikmati proses kemasukan ke hospital yang lebih lancar dan banyak lagi.',
      },
      easyApplication: {
        title: 'Sumbangan Berpatutan',
        description:
          'Dapatkan perlindungan RM250,000 dengan sumbangan serendah RM2.36 sehari.',
      },
    },
    'ezy-medical': {
      lifeTime: {
        title: 'Perlindungan Perubatan Sepanjang Hayat Tanpa Had',
        description:
          'Dapatkan perlindungan perubatan sepanjang hayat tanpa had dengan had tahunan yang tinggi sehingga RM350,000.',
      },
      charges: {
        title: 'Rundingan dan Caj Rawatan Psikiatri Pesakit Luar',
        description:
          'Lindungi kesihatan mental anda pada bila-bila masa, di mana-mana sahaja dengan pelan perlindungan kesihatan mental yang melindungi anda kecelaruan episod kemurungan utama, kecelaruan obsesif kompulsif, gangguan bipolar, gangguan tekanan selepas trauma dan banyak lagi.',
      },
      cashless: {
        title: 'Kemasukan Hospital Tanpa Tunai',
        description:
          ' Surat Jaminan disediakan hanya dengan satu sentuhan melalui aplikasi Etiqa+.',
      },
      affordable: {
        title: 'Premium Berpatutan',
        description:
          'Dapatkan perlindungan sehingga RM350,000  dengan premium serendah RM2.76 sehari.',
      },
    },
    'easy-health': {
      lifeTime: {
        title: 'Perlindungan Perubatan Sepanjang Hayat Tanpa Had',
        description:
          'Dapatkan perlindungan perubatan sepanjang hayat tanpa had dengan had tahunan yang tinggi sehingga RM350,000.',
      },
      extensive: {
        title: 'Rundingan dan Caj Rawatan Psikiatri Pesakit Luar',
        description:
          'Lindungi kesihatan mental anda pada bila-bila masa, di mana-mana sahaja dengan pelan perlindungan kesihatan mental yang melindungi anda kecelaruan episod kemurungan utama, kecelaruan obsesif kompulsif, gangguan bipolar, gangguan tekanan selepas trauma dan banyak lagi.',
      },
      cashless: {
        title: 'Kemasukan Hospital Tanpa Tunai',
        description:
          'Surat Jaminan disediakan hanya dengan satu sentuhan melalui aplikasi Etiqa+.',
      },
      easyApplication: {
        title: 'Permohonan Mudah',
        description:
          'Dapatkan perlindungan segera tanpa perlu membuat pemeriksaan kesihatan. Anda hanya perlu menjawab beberapa soalan berkaitan kesihatan untuk melengkapkan permohonan anda secara dalam talian.',
      },
    },
  },
  forms: {
    quotationForm: {
      title: 'Diri Sendiri',
      name: 'Nama',
      male: 'Lelaki',
      female: 'Perempuan',
      nric: 'No. Kad Pengenalan',
      kidNric: 'NRIC/MyKid',
      occupation: 'Pekerjaan',
      email: 'E-mel',
      placeholder: {
        name: 'Sila isikan nama penuh anda',
        nric: 'Sila masukkan no. kad pengenalan',
        occupation: 'Sila pilih pekerjaan anda',
        email: 'Sila isikan e-mel anda',
      },
      button: 'Teruskan sekarang',
    },
    memberForm: {
      ' Please provide the following details to proceed with the application.':
        ' Sila isi maklumat yang diperlukan untuk meneruskan permohonan.',
      'You may proceed with their application separately.':
        'Anda masih boleh meneruskan permohonan mereka secara berasingan.',
      isBelow:
        'Maklumat Ibubapa/Penjaga diperlukan untuk ahli yang berumur 16 tahun dan ke bawah.',
      forSpouse: {
        takaful:
          'Maklumat pemilik sijil diperlukan untuk perlindungan pasangan anda.',
        insurance:
          'Maklumat pemilik polisi diperlukan untuk perlindungan pasangan anda.',
      },
      isAbove:
        'Perlindungan berasingan yang diperlukan untuk anak/ahli berumur 16 tahun ke atas.',
    },
  },
  button: {
    'Get Quote': 'Mohon Sekarang',
    Verify: 'Semak',
    'No, try again': 'Tidak, cuba lagi',
    'Yes, This Is me': 'Ya betul, ini saya',
  },
  'I am': 'Saya adalah',
  'I would like to protect my': 'Saya ingin melindungi',
  'Valid for Malaysian citizen only':
    'Sah untuk warganegara Malaysia sahaja, untuk Bukan Warganegara Malaysia sila hubungi <email>info@etiqa.com.my</email>. ',
  'Get a Free Quotation in Minutes':
    'Dapatkan Sebut Harga Dalam Beberapa Minit Sahaja',
  'Ensure these criteria are met to proceed':
    'Sila pastikan kriteria berikut dipenuhi untuk meneruskan:',
  'You are a Malaysian citizen.': 'Anda adalah <1>warganegara Malaysia</1>.',
  'Your age is between 17 to 55 years old to purchase as an adult.':
    'Umur anda antara <1>17 hingga 55 tahun</1> untuk mendaftar sebagai <1>orang dewasa</1>.',
  agentForm: {
    'This plan is designated for agent only':
      'Pelan ini khas untuk ejen sahaja',
    'Log in with my agent code': 'Log masuk dengan kod ejen saya',
    agentCode: 'Kod ejen',
    welcome: 'Selamat Datang {{agentName}}.',
    'Is this your agent account?': 'Adakah ini akaun ejen anda?',
    placeholder: {
      agentCode: 'Contoh: kei2020',
    },
  },
  coverageNeeds: {
    unsure: 'Tidak pasti tentang keperluan perlindungan anda? ',
    checkCalculator:
      'Sila semak <b>Analisis Keperluan dan Kalkulator Belanjawan Kewangan</b> untuk menentukan perlindungan anda.',
    checkItOut: 'Semak sini',
    link: 'https://www.mycoverage.my/kalkulator/perlindungan_hayat_bertempoh/',
  },
  affiliate: {
    agentCode: 'Kod Ejen',
    agentBranch: 'Cawangan Ejen',
  },
};
